import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CaseAccessBase from "@/pages/CaseAccess.Base.vue";

export default defineMosaicComponent<typeof CaseAccessBase>("pages/CaseAccess");
